import GalleryPage from './pages/GalleryPage.jsx';
import './styles/gallery.css';

/** Design system gallery: every base component, in the current theme. */
const GalleryScreen = () => {
  return (
    <div className="gallery-screen">
      <GalleryPage />
    </div>
  );
};

export default GalleryScreen;
